import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { postInformationToDiscord, saveEmailId } from "../../action/HomePage.action";
import ContactForm from "./ContactForm";
import ContactInfo from "./ContactInfo";
import ContactMap from "./ContactMap";
import ThankYouPopup from "./ThankYouPopup";
import "./ContactUs.css";

const GOOGLE_SHEETS_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzvO8h7eHRZOhqnUSRPsMYg6knbLixJNkkdgFoOQuAmXqQE6dhs0K1kSNEt2kSz227OEA/exec";

const submitToGoogleSheets = async (data) => {
  try {
    const url = GOOGLE_SHEETS_SCRIPT_URL;

    const body = new URLSearchParams({
      sheetName: "Contact Us",
      Name: data.name || "",
      Email: data.email || "",
      Mobile: data.mobile || "",
      Subject: data.subject || "",
      Message: data.message || "",
    });

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body,
    });

    await response.text();
    return true;
  } catch (error) {
    console.error("Submission failed:", error);
    return false;
  }
};

const ContactUs = () => {
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();

  const handleFormSubmit = async (formData) => {
    try {
      dispatch(saveEmailId(formData.email));
      dispatch(postInformationToDiscord(formData));
      await submitToGoogleSheets(formData);
      setShowPopup(true);
      return true;
    } catch (error) {
      console.error("Error submitting form:", error);
      return false;
    }
  };

  return (
    <>
      <section id="home-contact" className="home-contact light-background">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row">
            <div className="col-lg-6">
              <ContactInfo />
            </div>
            <div className="col-lg-6">
              <ContactForm onSubmit={handleFormSubmit} />
            </div>
          </div>
        </div>
      </section>
      <ContactMap />
      {showPopup && <ThankYouPopup onClose={() => setShowPopup(false)} />}
    </>
  );
};

export default ContactUs;
